"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const forms_v2_1 = __importStar(require("@kyruus/forms-v2"));
const PatientStaticInfo_1 = __importDefault(require("./PatientStaticInfo"));
const RegForm_1 = require("../RegForm");
const utils_1 = require("../../lib/utils");
const xstate_1 = require("xstate");
const RegisterPatientForWaitlist_1 = __importDefault(require("../RegForm/RegisterPatientForWaitlist"));
const EhrPatientInfo = ({ formBreakpoints, ehrPatientDemographics, bannerText, handleChange, handleTrack, handleSubmit, updatedFields, fields, isRequiredMarker, isNotRequiredMarker, disclaimer, addOns, provider, config, service, formRef, waitlistRef }) => {
    const { name, dob, gender, address, email, phones } = ehrPatientDemographics;
    // if we have valid demographic data (from ehrPatientDemographics)
    // we don't need a corresponding field for the editable portion of the form
    if ((0, utils_1.isValidEHRName)(name)) {
        fields = fields.filter((field) => field.type !== 'name');
    }
    if ((0, utils_1.isValidEHRDOB)(dob)) {
        fields = fields.filter((field) => field.type !== 'dob');
    }
    if ((0, utils_1.isValidEHRGender)(gender)) {
        // Gender form fields are type `simpleSelect`, need to use path instead
        fields = fields.filter((field) => field.path !== 'patient.gender');
    }
    if ((0, utils_1.isValidEHRAddress)(address)) {
        fields = fields.filter((field) => field.type !== 'address');
    }
    const phoneConfig = fields.find((field) => field.type === 'phone');
    const entityData = {
        patient: {
            email,
            phone: (0, utils_1.getPhoneEhrPatientDemographics)(phones, phoneConfig)
        }
    };
    return (react_1.default.createElement("div", { "data-testid": "EhrPatientInfo" },
        react_1.default.createElement(PatientStaticInfo_1.default, { name: name, dob: dob, gender: gender, address: address, bannerText: bannerText, fields: fields }),
        react_1.default.createElement(forms_v2_1.default, { breakpoints: formBreakpoints, onChange: handleChange, onSubmit: handleSubmit, onTrack: handleTrack, updatedFields: updatedFields, fields: fields, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker, hideDefaultSubmit: true, entityData: entityData, formRef: formRef },
            (0, forms_v2_1.getAddOns)(addOns, handleTrack),
            react_1.default.createElement(forms_v2_1.Footer, null, ({ handleSubmit, handleTrack }) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(RegisterPatientForWaitlist_1.default, { service: service, ref: waitlistRef }),
                react_1.default.createElement(RegForm_1.RegFormFooterContent, { handleSubmit: handleSubmit, disclaimer: disclaimer, handleTrack: handleTrack, service: service, config: config, provider: provider })))))));
};
EhrPatientInfo.defaultProps = {
    ehrPatientDemographics: null,
    isRequiredMarker: undefined,
    isNotRequiredMarker: undefined,
    disclaimer: [],
    bannerText: null
};
EhrPatientInfo.propTypes = {
    formBreakpoints: prop_types_1.default.shape({
        screen_medium: prop_types_1.default.string
    }),
    ehrPatientDemographics: prop_types_1.default.shape({
        name: prop_types_1.default.shape({
            first: prop_types_1.default.string,
            middle: prop_types_1.default.string,
            last: prop_types_1.default.string
        }),
        dob: prop_types_1.default.string,
        gender: prop_types_1.default.string,
        address: prop_types_1.default.shape({
            street1: prop_types_1.default.string,
            street2: prop_types_1.default.string,
            city: prop_types_1.default.string,
            state: prop_types_1.default.string,
            zip: prop_types_1.default.string
        }),
        shouldShowBanner: prop_types_1.default.bool,
        email: prop_types_1.default.string,
        phones: prop_types_1.default.arrayOf(prop_types_1.default.object)
    }),
    handleChange: prop_types_1.default.func.isRequired,
    handleTrack: prop_types_1.default.func.isRequired,
    handleSubmit: prop_types_1.default.func.isRequired,
    updatedFields: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,
    fields: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,
    isRequiredMarker: prop_types_1.default.string,
    isNotRequiredMarker: prop_types_1.default.string,
    disclaimer: prop_types_1.default.arrayOf(prop_types_1.default.string),
    bannerText: prop_types_1.default.string,
    addOns: prop_types_1.default.object,
    provider: prop_types_1.default.object,
    config: prop_types_1.default.object,
    service: prop_types_1.default.instanceOf(xstate_1.Interpreter).isRequired,
    formRef: prop_types_1.default.shape({
        current: prop_types_1.default.instanceOf(prop_types_1.default.object)
    }),
    waitlistRef: prop_types_1.default.shape({
        current: prop_types_1.default.instanceOf(prop_types_1.default.object)
    })
};
exports.default = EhrPatientInfo;
//# sourceMappingURL=EhrPatientInfo.js.map